// Residence page toggle switch
const residenceSwitch = document.querySelector('.switch-container');

if (residenceSwitch) {
  const switchSelection = residenceSwitch.querySelector(".switch-selection");
  const switchOptions = residenceSwitch.querySelectorAll("p");
  const title = document.querySelector('.title');
  const topImage = document.querySelector('.top-image');
  const subtitle = document.querySelector('.subtitle');
  const map = document.querySelector(".layout-image");
  const leftImage = document.querySelector(".left-image");
  const leftCaption = document.querySelector(".left-caption");
  const rightImage = document.querySelector(".right-image");
  const rightCaption = document.querySelector(".right-caption");
  const crescentItems = document.querySelectorAll(".crescent");
  const parksideItems = document.querySelectorAll(".parkside");
  const slider = document.querySelector(".swiper-scrollbar");

  switchOptions.forEach(option => {
    option.addEventListener("click", () => {
      if (!option.classList.contains("active")) {
        switchSelection.classList.toggle("active");
        switchOptions.forEach(option => {
          option.classList.toggle("active");
        });
        crescentItems.forEach(toggleHiddenItems);
        parksideItems.forEach(toggleHiddenItems);
        // slider.style.opacity = 0;
        // setTimeout(() => {
        //     slider.style.opacity = 1;
        // }, 150)
      }

      if (window.location.hash == "#parkside") {
        window.location.hash = "#crescent";
      } else {
        window.location.hash = "#parkside";
      }
    })
  })

  function toggleHiddenItems(item) {
    if (!item.classList.contains("hidden")) {
      item.classList.toggle("opaque");
      setTimeout(() => {
        item.classList.toggle("hidden");

      }, 150);
    } else {
      setTimeout(() => {
        item.classList.toggle("hidden");
      }, 150);
      setTimeout(() => {
        item.classList.toggle("opaque");
      }, 160);
    }
  }

  // Residence Page hash
  if (window.location.hash == "#parkside") {
    const switchSelection = document.querySelector(".switch-selection");
    const crescentSelector = document.querySelector(".crescent-selector");
    const parksideSelector = document.querySelector(".parkside-selector");

    switchSelection.classList.add("active");
    switchSelection.style.transition = "none";
    crescentSelector.classList.remove("active");
    parksideSelector.classList.add("active");
    parksideItems.forEach(item => {
      item.classList.add("opaque");
      item.classList.remove("hidden");
    })
    crescentItems.forEach(item => {
      item.classList.remove("opaque");
      item.classList.add("hidden");
    })
    setTimeout(() => {
      switchSelection.style.transition = "margin 0.3s ease-out";
    }, 100)

  }
}


const propertyIcons = document.querySelectorAll(".property-marker");
const propertyPopups = document.querySelectorAll(".property-popup");
let activePropertyPopup;
propertyIcons.forEach((icon, i) => {
  icon.addEventListener("click", () => {
    enablePropertyIcons();
    disablePropertyIcons(icon);
    togglePropertyPopup(propertyPopups[i], icon)
  })
})

function togglePropertyPopup(currentPopup, currentIcon) {
  if (currentPopup.classList.contains("active")) {
    currentPopup.classList.remove("active");
    currentIcon.classList.remove("active");
    enablePropertyIcons();
    activePropertyPopup = null;
  } else {
    currentPopup.classList.add("active");
    currentIcon.classList.add("active");
    activePropertyPopup = currentPopup;
  }

  propertyPopups.forEach(popup => {
    if (popup !== currentPopup) {
      popup.classList.remove("active");
    }
  })
}

function closeAllPopups() {
  propertyPopups.forEach(popup => {
    popup.classList.remove("active");
  })
}

function disablePropertyIcons(activeIcon) {
  propertyIcons.forEach(icon => {
    if (icon !== activeIcon) {
      icon.classList.add("disabled");
    }
  })
}

function enablePropertyIcons() {
  propertyIcons.forEach(icon => {
    icon.classList.remove("disabled");
  })
}

window.addEventListener("click", (e) => {
  if (activePropertyPopup) {
    activePropertyPopup = null;
  } else if (!e.target.closest(".property-popup")) {
    closeAllPopups();
    enablePropertyIcons();
  }
})